import { createContext, useContext, useEffect, useState } from "react";
import { useUser } from "../UserContext";
// import axios from "axios"
// import { useUser } from "../UserContext";

const ValueContext = createContext();

export const ValueProvider = ({ children }) => {
  const { marketPlace, industry } = useUser()
  const [outputValue, setOutputValue] = useState(0);
  const [outputValueThirty, setOutputValueThirty] = useState(0);
  const [outputValueSixty, setOutputValueSixty] = useState(0);
  const [machinaryFinancing, setMachinaryFinancing] = useState(0);
  const [lossesPercentagem, setLossesPercentagem] = useState(3);
  const [salary, setSalary] = useState(0);
  const [entranceValue, setEntranceValue] = useState(10000000);
  const [entranceValueMarket, setEntranceValueMarket] = useState(10000000);
  const [boringMerchandise, setBoringMerchandise] = useState(0);
  const [tax, setTax] = useState(0);
  const [spendsMarketing, setspendsMarketing] = useState(0);
  const [incomeFinancialExpenses, setIncomeFinancialExpenses] = useState(0);
  const [personalExpenses, setPersonalExpenses] = useState(0);
  const [trainingExpenses, setTrainingExpenses] = useState(0);
  const [cmv, setCmv] = useState(0);
  const [grossMargin, setGrossMargin] = useState(0);
  const [rent, setRent] = useState(0);
  const [others, setOthers] = useState(0);
  const [profitPrejudice, setProfitPrejudice] = useState(0);

  const storagedIndustria = JSON.parse(localStorage.getItem('@App:industria'));

  useEffect(() => {
    setEntranceValue(industry?.investimentoSaldo);
    setOutputValue(outputValue);
    setBoringMerchandise(boringMerchandise);
    setTax(tax);
    setspendsMarketing(spendsMarketing);
    setIncomeFinancialExpenses(incomeFinancialExpenses);
    setPersonalExpenses(personalExpenses);
    setTrainingExpenses(trainingExpenses);
    setCmv(cmv);
    setGrossMargin(grossMargin);
    setRent(rent);
    setOthers(others);
    setProfitPrejudice(profitPrejudice);
  }, [
    storagedIndustria,
    outputValue,
    industry,
    boringMerchandise,
    tax,
    spendsMarketing,
    incomeFinancialExpenses,
    personalExpenses,
    trainingExpenses,
    cmv,
    grossMargin,
    rent,
    others,
    profitPrejudice,
  ]);

  useEffect(() => {
    if (!marketPlace?.supermercado) return
    console.log(marketPlace);
    setEntranceValueMarket(marketPlace?.investimentoSaldo);
  }, [marketPlace])
  return (
    <ValueContext.Provider
      value={{
        outputValue,
        setOutputValue,
        outputValueThirty,
        setOutputValueThirty,
        outputValueSixty,
        setOutputValueSixty,
        machinaryFinancing,
        setMachinaryFinancing,
        salary,
        setSalary,
        lossesPercentagem,
        setLossesPercentagem,
        entranceValue,
        setEntranceValue,
        entranceValueMarket,
        setEntranceValueMarket,
        boringMerchandise,
        setBoringMerchandise,
        tax,
        setTax,
        spendsMarketing,
        setspendsMarketing,
        incomeFinancialExpenses,
        setIncomeFinancialExpenses,
        personalExpenses,
        setPersonalExpenses,
        trainingExpenses,
        setTrainingExpenses,
        cmv,
        setCmv,
        grossMargin,
        setGrossMargin,
        rent,
        setRent,
        others,
        setOthers,
        profitPrejudice,
        setProfitPrejudice
      }}
    >
      {children}
    </ValueContext.Provider>
  );
};

export const useValue = () => useContext(ValueContext);
